import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Style from "./error-styles";
import errorImage from "../../assets/images/error.png";

export default function Error() {
  const classes = Style();

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      className={classes.root}
    >
      <Grid item xs className={classes.content}>
        <img
          src={errorImage}
          alt="Ocorreu um erro ao tentar executar a sua solicitação."
        />
        <Typography variant="h1" gutterBottom>
          Que pena!
        </Typography>
        <Typography variant="h4" gutterBottom>
          Ocorreu um erro ao tentar executar a sua solicitação.
        </Typography>
        <Typography variant="h5">Por favor, tente novamente!</Typography>
      </Grid>
    </Grid>
  );
}
